import CryptoJS from 'crypto-js';

/** Igual ao PHP: hash_hmac('sha256', $cnpj . $timestamp, 'chave_secreta') */
const CHAVE_SECRETA = 'chave_secreta'

/** Unix em segundos (~10 dígitos), não use Date.now() em ms (~13 dígitos). */
function unixTimestampSeconds() {
  return Math.floor(Date.now() / 1000)
}

/** @param {string} cnpj */
export function buildBarrosPremiumLoginUrl(cnpj) {
  if (!cnpj) return null

  const ts = String(unixTimestampSeconds())
  const message = `${cnpj}${ts}`
  const token = CryptoJS.HmacSHA256(message, CHAVE_SECRETA).toString(
    CryptoJS.enc.Hex
  )

  return `https://barros.com.br/login-via-cnpj/${encodeURIComponent(cnpj)}/${encodeURIComponent(token)}?ts=${encodeURIComponent(ts)}`
}

export function openBarrosPremiumSite() {
  try {
    const raw = localStorage.getItem('@barrosAuth')
    if (!raw) return
    const auth = JSON.parse(raw)
    const cnpj = auth?.cnpj
    if (!cnpj) return
    const url = buildBarrosPremiumLoginUrl(cnpj)
    if (!url) return
    window.open(url, '_blank', 'noopener,noreferrer')
  } catch {
    // ignore malformed storage
  }
}
